const processTypes = [
  { label: 'Interno', value: 'internal' },
  { label: 'Externo', value: 'external' },
  { label: 'Mixto', value: 'mixed' }
];

const statuses = [
  { label: 'Generado', value: 'generated' },
  { label: 'Activo', value: 'active' },
  { label: 'Suspendido', value: 'suspended' },
  { label: 'Desierto', value: 'deserted' },
  { label: 'Cerrado', value: 'closed' }
];

const workSchedules = [
  { label: 'Media jornada', value: 'part_time' },
  { label: 'Jornada completa', value: 'full_time' },
  { label: 'Freelance', value: 'freelance' },
  { label: 'Práctica', value: 'practice' }
];

const expertiseLevels = [
  { label: 'Junior', value: 'junior' },
  { label: 'Semi Senior', value: 'semi_senior' },
  { label: 'Senior', value: 'senior' },
  { label: 'Experto', value: 'expert' },
  { label: 'Menos 1 año', value: 'less_1_year' },
  { label: '2 - 4 años', value: '_2_4_years' },
  { label: '5 – 8 años', value: '_5_8_years' },
  { label: 'Mayor 8 años', value: 'more_8_years' }
];

const remotes = [
  { label: 'Sin opción remota', value: 'no_remote_option' },
  { label: 'Remoto temporalmente', value: 'temporarily_remote' },
  { label: 'Remoto sólo localmente', value: 'remote_only_locally' },
  { label: 'Totalmente remoto', value: 'totally_remote' },
  { label: 'Presencial', value: 'on_site' },
  { label: 'Híbrida', value: 'hybrid' },
  { label: 'Teletrabajo', value: 'remote_work' }
];

const remotesPreferred = ['on_site', 'hybrid', 'remote_work'];

export { processTypes, statuses, workSchedules, expertiseLevels, remotes, remotesPreferred };
